import aaImg from "../assets/img/AA.png";
import govImg from "../assets/img/gov.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <>
      <footer id="footer">

        {/* Z：下方連絡區 */}
        <a
          className="accesskey"
          href="#aZ"
          id="aZ"
          accessKey="Z"
          title="下方連絡區"
        >
          :::
        </a>

        <div className="container py-4">
          <div className="row">

            <div className="copyright col-lg-4">
              &copy;{" "}
              <strong>
                <span>
                  {year} 金融監督管理委員會檢查局
                </span>
              </strong>{" "}
              版權所有
            </div>

            <div className="address col-lg-5">
              22041 新北市板橋區縣民大道2段7號14樓
              電話：(02)8968-0899
            </div>

            <div className="credits col-lg-3">

              <a
                href="https://accessibility.moda.gov.tw/Applications/Detail?category=20261014181819"
                title="無障礙網站"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={aaImg}
                  width="88"
                  height="31"
                  alt="通過AA無障礙網頁檢測"
                />
              </a>

              &nbsp;&nbsp;

              <a
                href="https://www.gov.tw"
                title="開啟新視窗－我的E政府"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={govImg}
                  alt="我的E政府"
                />
              </a>

            </div>

          </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;
